import { ArrowDropDown, CheckBox, CheckBoxOutlineBlank, Lock, LockOpen } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { PossibleCalendarTypes } from "../MainCalendar";
import useRights from "@/shared/api/useRights";

const crewContentOptions = [
  { key: "showMaterial", name: "Material" },
  { key: "showLogistics", name: "Logistik" },
  { key: "showCrewMembers", name: "Kolonnenmitglieder" },
  { key: "showOtherStaff", name: "Zusätzliche Mitarbeiter" },
  { key: "showCrewResources", name: "Kolonnengeräte" },
  { key: "showOtherResources", name: "Zusätzliche Geräte" },
  { key: "showAutobookings", name: "Kolonnenreservierungen" },
] as const;

export default function SelectCalendarDialog({
  type,
  settings,
  setSettings,
}: {
  type: PossibleCalendarTypes;
  settings: { [key: string]: any };
  setSettings: (settings: { [key: string]: any }) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = !!anchorEl;

  const rights = useRights();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const setAllContent = (visible: boolean) => {
    setSettings({ ...settings, ...Object.fromEntries(crewContentOptions.map(({ key }) => [key, visible])) });
    close();
  };

  return (
    <Fragment>
      {"DISPOSITION" in rights && type === "RESOURCES" ? (
        <Tooltip title={settings["moveOnlyResource"] ? "Nur das Gerät verschieben" : "Gesamte Planung verschieben"}>
          <IconButton
            size="small"
            onClick={() =>
              setSettings({
                ...settings,
                moveOnlyResource: !settings["moveOnlyResource"],
              })
            }
          >
            {settings["moveOnlyResource"] ? <LockOpen fontSize="small" /> : <Lock fontSize="small" />}
          </IconButton>
        </Tooltip>
      ) : null}
      {type === "CREWS" ? (
        <Button onClick={handleClick} endIcon={<ArrowDropDown />}>
          Ansicht
        </Button>
      ) : null}
      <Menu open={open} anchorEl={anchorEl} onClose={close}>
        {type === "CREWS" ? [
          <MenuItem key="show-all" onClick={() => setAllContent(true)}>Alle einblenden</MenuItem>,
          <MenuItem key="hide-all" onClick={() => setAllContent(false)}>Alle ausblenden</MenuItem>,
          <Divider key="content-divider" />,
        ] : null}
        {crewContentOptions.map((x) => (
          <MenuItem
            onClick={() => {
              setSettings({ ...settings, [x.key]: !settings[x.key] });
              close();
            }}
            key={x.key}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              {!!settings[x.key] ? <CheckBox /> : <CheckBoxOutlineBlank />}
              <div>{x.name}</div>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </Fragment>
  );
}
